import i18n from "../../../../../i18n";
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    // {
    //     prop:'code_detail',
    //     label: 'Código',
    //     minWidth: 150
    // },
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      fixed: true,
    },
    {
      prop: 'lot_name',
      label: i18n.t('common_words.allotment'),
      minWidth: 100,
      fixed: true,
    },
    {
      prop: 'date_save',
      label: i18n.t('common_words.detection_date'),
      minWidth: 100,
      fixed: true,
    },
    {
      prop: 'outbreak',
      label: i18n.t('diseases.outbreaks_number'),
      minWidth: 100,
      fixed: false,
    },
    {
      prop: 'cases',
      label: i18n.t('diseases.cases_quantity'),
      minWidth: 100,
    },
    // {
    //   prop:'disease_name',
    //   label:'Plaga o Enfermedad',
    //   minWidth: 170
    // },
    // {
    //   prop: 'disease_status',
    //   label: 'Estado o Nivel',
    //   minWidth: 150
    // },

    // {
    //     prop:'latitude',
    //     label:'Latitud',
    //     minWidth: 150
    // },
    // {
    //     prop:'longitude',
    //     label:'Longitud',
    //     minWidth: 150
    // }
  ];

  return { Table };

};

export default configTable;
